import React, { useState } from "react";
import { Table, Form } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";

const InvoiceTable = () => {
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const handleDownload = (invoiceId) => {
    console.log(`Downloading invoice ${invoiceId}`);
    // Your download logic here (API call, file generation, etc.)
  };

  const invoices = [
    { id: "0001", event: "Event 1", unit: 1, amount: "$60", date: "16-Jan-2025" },
    { id: "0001", event: "Event 2", unit: 1, amount: "$60", date: "16-Jan-2025" },
    { id: "0001", event: "Event 3", unit: 1, amount: "$60", date: "16-Jan-2025" },
    { id: "0001", event: "Event 4", unit: 1, amount: "$60", date: "16-Jan-2025" },
    { id: "0001", event: "Event 5", unit: 1, amount: "$60", date: "16-Jan-2025" },
    { id: "0001", event: "Event 6", unit: 1, amount: "$60", date: "16-Jan-2025" },
    { id: "0001", event: "Event 7", unit: 1, amount: "$60", date: "16-Jan-2025" },
    { id: "0001", event: "Event 8", unit: 1, amount: "$60", date: "16-Jan-2025" },
  ];

  // Handle row selection
  const handleCheckboxChange = (event, invoiceId) => {
    if (event.target.checked) {
      setSelectedInvoices([...selectedInvoices, invoiceId]);
    } else {
      setSelectedInvoices(selectedInvoices.filter((id) => id !== invoiceId));
    }
  };

  // Select all invoices
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedInvoices(invoices.map((invoice, index) => index));
    } else {
      setSelectedInvoices([]);
    }
  };

  return (
    <div className="table-container">
      <Table hover responsive className="invoice-table">
        <thead>
          <tr>
            <th>
              <Form.Check
                type="checkbox"
                onChange={handleSelectAll}
                checked={selectedInvoices.length === invoices.length}
              />
            </th>
            <th>Invoice Id</th>
            <th>Event Name</th>
            <th>Unit</th>
            <th>Amount</th>
            <th>Payment Date</th>
            <th>Invoice</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice, index) => (
            <tr key={index}>
              <td>
                <Form.Check
                  type="checkbox"
                  checked={selectedInvoices.includes(index)}
                  onChange={(e) => handleCheckboxChange(e, index)}
                />
              </td>
              <td>Invoice#{invoice.id}</td>
              <td>{invoice.event}</td>
              <td>{invoice.unit}</td>
              <td>{invoice.amount}</td>
              <td>{invoice.date}</td>
              <td>
              <button className="download-link" onClick={() => handleDownload(invoice.id)}>
                Download <FiDownload />
              </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default InvoiceTable;
